import OLFormatGeoJSON from 'ol/format/GeoJSON'
import { all as OLLoadingStrategyAll } from 'ol/loadingstrategy'
import OLSourceVector from 'ol/source/Vector'

import PoziAPIGSheet from 'api/gsheet'
import LoaderHandleGeoJSON, { LoaderFailed } from 'config/LoaderHandleGeoJSON'
import { setLayerLoadInProgress } from 'drawer/tabs/layers/actions'

export default function (layer) {
  console.log('Loader ' + layer.config.spatial.loader + ' loading geojson for layer: ' + layer.title)

  const geojsonSourceOpts = {
    format: new OLFormatGeoJSON(),
    crossOrigin: 'Anonymous',
    loader: function (extent, resolution, projection, success, failure) {
      if (!layer.config.spatial) {
        console.log('Cannot load gsheet without spatial options.')

        failure()

        return false
      } else if (!layer.config.spatial.params) {
        console.log('No gsheet params found, set defaults.')
        layer.config.spatial.params = {}
        layer.config.spatial.params.key = ''
        layer.config.spatial.params.tq = ''
      }

      if (layer.config.spatial.url.indexOf('<id>') > -1) {
        layer.config.spatial.url = layer.config.spatial.url.replace('&tq=select * where A=<id>', '')
      }

      window.store.dispatch(setLayerLoadInProgress(layer.titleid))

      PoziAPIGSheet()
        .getDataAsGeoJSON(layer.config.spatial.url, layer.config.spatial.params.key, layer.config.spatial.params.tq)
        .then(function (geojson) {
          LoaderHandleGeoJSON(geojson, projection, geojsonSource, layer, success)
        })
        .catch(function (err) {
          LoaderFailed(layer, err, failure)
        })
    },
    strategy: OLLoadingStrategyAll,
    projection: 'EPSG:3857'
  }

  const geojsonSource = new OLSourceVector(geojsonSourceOpts)

  return geojsonSource
}
